import './bootstrap';
import '../css/app.css';
import {createApp, h} from 'vue';
import {createInertiaApp, router} from '@inertiajs/vue3';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {ZiggyVue} from 'ziggy-js';
import {Ziggy} from "@/ziggy.js";
import {createPinia} from 'pinia'
import WebSocketHandler from "@/plugins/WebSocketHandler.js";
import * as Sentry from "@sentry/vue";
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isToday from 'dayjs/plugin/isToday'
import 'dayjs/locale/ru'
import {getActiveLanguage, i18nVue} from "laravel-vue-i18n";
import {registerChunkErrorRecovery} from "@/helper.js";
import {isThirdPartyGsiClientError} from "@/sentry.js";
import {updateCanonicalAndOgUrl} from "@/seo/updateCanonicalOnNavigate.js";

dayjs.extend(customParseFormat)
dayjs.extend(isToday)

registerChunkErrorRecovery()

// See updateCanonicalOnNavigate.js's own docblock for why this is needed on top of <Head>.
router.on('navigate', () => updateCanonicalAndOgUrl());

const pinia = createPinia()
const appName = import.meta.env.VITE_APP_NAME ?? 'AnyKod.com';

// noinspection JSIgnoredPromiseFromCall
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({el, App, props, plugin}) {
        const app = createApp({render: () => h(App, props)})
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(pinia)
            .use(WebSocketHandler, {auth: props.initialPage.props.auth, reverb: props.initialPage.props.reverb})
            .use(i18nVue, {
                lang: props.initialPage.props.lang,
                resolve: lang => {
                    const languages = import.meta.glob('../../lang/*.json', {eager: true});
                    return languages[`../../lang/${lang}.json`].default;
                }
            })
        Sentry.init({
            app,
            dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: 0.1,
            environment: import.meta.env.APP_ENV,
            beforeSend: (event) => isThirdPartyGsiClientError(event) ? null : event,
        });
        Sentry.attachErrorHandler(app, {logErrors: true});
        dayjs.locale(getActiveLanguage())
        return app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
})
